<script>
import ProdutoGroupListVue from '@/app/modules/contacard/produto/groups/ProdutoGroupList.vue';
import ProdutoTemplateRequest from '@/app/modules/contacard/produto/templates/produto/ProdutoTemplateRequest';
import UserExpandableGiftCardListVue from 'App/users/components/tables/UserExpandableGiftCardList.vue';

export default {
  name: 'UserGiftCardList',
  extends: ProdutoGroupListVue,
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    hideEdit: true,
    hideDelete: true,
    hideTableBottom: true,
    showExpand: true,
    requestClass: ProdutoTemplateRequest,
    actionOptions: [],
    expandComponent: UserExpandableGiftCardListVue,
  }),
  computed: {
    storeId() {
      return this.value;
    },
  },
  methods: {
    prepareRequest() {
      return this.requestClass.listAgrupamentoByLoja(
        this.storeId,
      );
    },
    prepareData(data = []) {
      return data.map(
        (item) => ({
          ...item,
          storeId: this.storeId,
        }),
      );
    },
  },
};
</script>
